// extracted by mini-css-extract-plugin
export default {"summary":"theme_summary__xq+vO","item":"theme_item__yvoXu","value":"theme_value__Eiqfg","label":"theme_label__6lFVD","loader":"theme_loader__JW2Nx"};